// extracted by mini-css-extract-plugin
module.exports = {"container":"Logo_container__2Slk3","logoImg":"Logo_logoImg__1CA_T","logoTxt":"Logo_logoTxt__2dS00"};